export default "__VITE_ASSET__di2yUnnm__"